import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const getDefaultState = () => {
  return {
    user: {
      id: null
    },
    purchasedBids: 0,
    selectedClientBid: null,
    clientCase: {
      form: {
        fields: [{id: null}]
      },
      response: {
        answers: [
          {choice: '', label: ''}
        ]
      }
    }
  }
}

const state = getDefaultState()

export default new Vuex.Store({
  state: getDefaultState(),
  mutations: {
    addClientCase: (state, clientCase) => { state.clientCase = clientCase },
    addSelectedClientBid: (state, bid) => { state.selectedClientBid = bid },
    resetState: state => Object.assign(state, getDefaultState()),
    setPurchasedBids: (state, count) => { state.purchasedBids = count },
    incrementPurchasedBids: (state, count) => { state.purchasedBids += count },
    decrementPurchasedBids: (state, count) => { state.purchasedBids -= count },
  },
  getters: {
    clientCase: (state) => state.clientCase,
    selectedClientBid: (state) => state.selectedClientBid,
    purchasedBids: (state) => state.purchasedBids,
  },
  actions: {}
});
